module.exports = __webpack_public_path__ + "img/offline.8938f797.svg";